import { render, staticRenderFns } from "./LgFinderPageAlmoxarifadoModal.vue?vue&type=template&id=56a6ba90"
import script from "./LgFinderPageAlmoxarifadoModal.vue?vue&type=script&lang=js"
export * from "./LgFinderPageAlmoxarifadoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports